module.exports = __webpack_public_path__ + "img/Trustpilot_ratings_4halfstar-RGB.50f44a58.svg";